<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Información de vista: {{tier1.longtitle}}</h4>
    <hr>

    <div class="form-group row">
        <!-- Configuracion de fomrulario exclusivo para mapa de interrelaciones -->
        <ng-container *ngIf="idTier1 == 29">
            <div class="textOnInput col-12">
                <!-- Controles de descripción -->
                <label class="form-label" for="inputText">Titulo</label>
                <input class="form-control" formControlName="shorttitle" autocomplete="off"
                    [class.is-invalid]="campoNoValido('shorttitle')" type="text">
                <small class="text-danger" *ngIf="campoNoValido('shorttitle')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-12">
                <!-- Controles de descripción -->
                <label class="form-label" for="inputText">Subtitulo</label>
                <textarea class="form-control" formControlName="summary" autocomplete="off"
                    [class.is-invalid]="campoNoValido('summary')" rows="3"></textarea>
                <small class="text-danger" *ngIf="campoNoValido('summary')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-12">
                <!-- Controles de descripción -->
                <label class="form-label" for="inputText">Detalle</label>
                <textarea class="form-control" formControlName="detail" autocomplete="off"
                    [class.is-invalid]="campoNoValido('detail')" rows="6"></textarea>
                <small class="text-danger" *ngIf="campoNoValido('detail')">Este campo es requerido</small>
            </div>
        </ng-container>

        <ng-container *ngIf="idTier1 == 25 || idTier1 == 26 || idTier1 == 27 || idTier1 == 28">
            <div class="textOnInput col-12">
                <!-- Configuracion de texto introdcutorio-->
                <label class="form-label" for="inputText">Texto introductorio</label>
                <textarea class="form-control" formControlName="summary" autocomplete="off"
                    [class.is-invalid]="campoNoValido('summary')" rows="6"></textarea>
                <small class="text-danger" *ngIf="campoNoValido('summary')">Este campo es requerido</small>
            </div>
        </ng-container>

        <ng-container *ngIf="idTier1 == 7 || idTier1 == 5 || idTier1 == 6 || idTier1 == 4 || idTier1 == 14">

            <!-- Primer archivo PDF -->
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">PDF Listado</label>
                <div class="label-container">
                    <div class="row">
                        <div class="col-md-12" style="margin-bottom: 10px;">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                        (click)="fileInputListado.click()">
                                        Cargar PDF Listado
                                    </button>
                                </div>
                                <input type="text" class="form-control" placeholder="PDF" formControlName="urllistado"
                                    autocomplete="off">
                            </div>
                            <input #fileInputListado class="form-file" type="file" id="input-file-pdf-listado"
                                (change)="onPdfChange($event, 1)" accept=".pdf" style="display: none;"
                                [ngClass]="{'is-invalid': campoNoValido('urllistado')}">
                        </div>
                        <div class="col-md-12">
                            <div class="pdf-item">
                                <span class="pdf-name" *ngIf="showPdf1Controls">1. {{ filenamePDF1 }}</span>
                                <button class="pdf-delete-button" (click)="removePdf(1)" *ngIf="showPdf1Controls"
                                    type="button">x</button>
                            </div>
                        </div>
                    </div>
                    <small class="text-danger" *ngIf="campoNoValido('urllistado')">Este campo es requerido</small>
                </div>
            </div>

            <!-- Segundo archivo PDF -->
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">PDF Documento metodológico</label>
                <div class="label-container">
                    <div class="row">
                        <div class="col-md-12" style="margin-bottom: 10px;">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                        (click)="fileInputMetodologico.click()">
                                        Cargar PDF Documento metodológico
                                    </button>
                                </div>
                                <input type="text" class="form-control" placeholder="PDF"
                                    formControlName="urlmetodologico" autocomplete="off">
                            </div>
                            <input #fileInputMetodologico class="form-file" type="file" id="input-file-pdf-metodologico"
                                (change)="onPdfChange($event, 2)" accept=".pdf" style="display: none;"
                                [ngClass]="{'is-invalid': campoNoValido('urlmetodologico')}">
                        </div>
                        <div class="col-md-12">
                            <div class="pdf-item">
                                <span class="pdf-name" *ngIf="showPdf2Controls">2. {{ filenamePDF2 }}</span>
                                <button class="pdf-delete-button" (click)="removePdf(2)" *ngIf="showPdf2Controls"
                                    type="button">x</button>
                            </div>
                        </div>
                    </div>
                    <small class="text-danger" *ngIf="campoNoValido('urlmetodologico')">Este campo es requerido</small>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="cancel()">Cancelar</button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>